import baseUrl from "../config/baseUrl";

const allAssignedChart = async ({ token, userID, isAdmin }) => {
  try {
    const response = await fetch(
      `${baseUrl}/apireact/dashboard_all_assigned_document_bar_chart_data?isAdmin=${isAdmin}`,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default allAssignedChart;
